import {
  categoryNavBarDataFetcher,
  tabByKeyFetcher,
} from '../../datafetchers/CategoryPage';
import {
  getFeedsData,
  getMostViewedWebContent,
} from '../../datafetchers/HomePage';
import { storeDataFetcher } from '../../datafetchers/Store';
import { getFilteredCategoryContent } from '../helper';

const queryKeys = {
  hi: 'hipage',
  bn: 'bnpage',
};

export async function getDifferentLanguageParentingData(context, lang) {
  const pageValue = context.query[queryKeys[lang]] || 0;
  const params = {
    skip: pageValue * 12,
    limit: 12,
  };
  // const hindiUserToken = "Bearer f1e2dad5-e986-433f-9a04-8d8d1b6c6c3e";
  const articleData = await getMostViewedWebContent(params, lang);
  return {
    props: {
      articleData,
      params,
      pageValue,
      language: lang,
      // hindiUserToken,
    },
  };
}

export const getParentingDataEnglish = async () => {
  const params = {
    skip: 0,
    limit: 20,
    key: 'web_parenting',
    isForGeneralTabFromWeb: true,
  };
  const parentingPageData = await tabByKeyFetcher(params);
  const feedParams = {
    type: 'for_you',
    filter: 'post',
    page: 1,
  };
  const questionData = await getFeedsData(feedParams);
  const recentlyAskedParams = {
    type: 'for_you',
    filter: 'post',
    page: 1,
    showLatestWebPosts: true,
  };
  const recentlyAskedQues = await getFeedsData(recentlyAskedParams);
  const categoryApiData = await categoryNavBarDataFetcher();
  const data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
  });
  return {
    props: {
      parentingPageData,
      questionData: questionData?.data?.posts,
      categoryData: getFilteredCategoryContent(data?.data?.categories),
      recentlyAskedQues: recentlyAskedQues?.data?.posts?.items?.slice(0, 3),
      language: 'en',
    },
  };
};
